import { render } from "./CIS-Partners-Item.vue?vue&type=template&id=63bd43fd"
import script from "./CIS-Partners-Item.vue?vue&type=script&lang=js"
export * from "./CIS-Partners-Item.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__